import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { SharedService } from './shared.service';
import { Config } from '../common/config';

@Injectable({
  providedIn: 'root'
})
export class QuestionsService {

  constructor(private http: HttpClient,
    public sharedService: SharedService,
  ) {

  }

  public getQuestionsByIds(post: any,supcode: any) {
    const body = JSON.stringify(post);
    if(Config.ROUTER_API_ENABLED) {
      return this.http.post(environment.ROUTER_API + 'wrapper/' + supcode + '/questions', this.sharedService.commonEncryptionMethod(body));
    }
    const questionsUrl = environment.INNOVATE_API_V2 + 'questions';
    return this.http.post(questionsUrl, body);
  }

}